(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[501],{

/***/ 15817:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/key-agent-sign-up",
      function () {
        return __webpack_require__(15945);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ LandingPageRoutes; },
/* harmony export */   "i": function() { return /* binding */ FooterRoutes; }
/* harmony export */ });
var FooterRoutes = {
    CCPA: "https://www.opendoor.com/privacy#ccpa",
    PRIVACY_POLICY: "https://opendoor.com/privacy",
    PRIVACY_REQUEST: "https://opendoor-privacy.relyance.ai/",
    TERMS_OF_SERVICE: "https://opendoor.com/terms"
};
var LandingPageRoutes = {
    AGENTS: "https://opendoor.com/agents"
};


/***/ }),

/***/ 15945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10677);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94746);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97402);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64971);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(44468);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(22470);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(25923);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(64370);
/* harmony import */ var _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74593);
/* harmony import */ var components_shared_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72683);










var Sentry = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_1__/* .globalObservability.getSentryClient */ .w.getSentryClient();
var ZAPIER_WEBHOOK_URL = "https://hooks.zapier.com/hooks/catch/19123831/277bvhz/";
var MAX_RETRIES = 3;
var RETRY_DELAY = 500;
var KeyAgentSignUp = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        firstName: "",
        lastName: "",
        email: undefined,
        phoneNumber: undefined,
        brokerage: "",
        mlsId: "",
        interests: [],
        agreeToMarketing: false,
        mlsName: ""
    }), formData = ref[0], setFormData = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}), fieldErrors = ref1[0], setFieldErrors = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}), fieldValidation = ref2[0], setFieldValidation = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isSubmitting = ref3[0], setIsSubmitting = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), showSuccessToast = ref4[0], setShowSuccessToast = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), showErrorToast = ref5[0], setShowErrorToast = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), showInputErrorToast = ref6[0], setShowInputErrorToast = ref6[1];
    var validateName = function(name) {
        var cleanedName = name.trim().replace(/[^a-zA-Z\s]/g, "");
        return cleanedName.length >= 1;
    };
    var handleInputChange = function(field, value) {
        setFormData(function(prev) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, field, value));
        });
        if (fieldErrors[field]) {
            setFieldErrors(function(prev) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, field, false));
            });
        }
    };
    var submitFormWithRetry = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
            var retryCount, response, ref, _$error, error;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        retryCount = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 0;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            9
                        ]);
                        return [
                            4,
                            fetch(ZAPIER_WEBHOOK_URL, {
                                method: "POST",
                                body: JSON.stringify((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, formData), {
                                    createdAt: new Date().toISOString()
                                }))
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (!!response.ok) return [
                            3,
                            5
                        ];
                        _$error = new Error("Failed to submit key agent sign upform");
                        (ref = Sentry.withScope) === null || ref === void 0 ? void 0 : ref.call(Sentry, function(scope) {
                            var ref;
                            scope.setExtras({
                                formData: formData,
                                responseStatus: response.status,
                                responseStatusText: response.statusText
                            });
                            (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, _$error);
                        });
                        if (!(retryCount < MAX_RETRIES)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, RETRY_DELAY);
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2,
                            submitFormWithRetry(retryCount + 1)
                        ];
                    case 4:
                        throw _$error;
                    case 5:
                        return [
                            2,
                            response
                        ];
                    case 6:
                        error = _state.sent();
                        if (!(retryCount < MAX_RETRIES)) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, RETRY_DELAY);
                            })
                        ];
                    case 7:
                        _state.sent();
                        return [
                            2,
                            submitFormWithRetry(retryCount + 1)
                        ];
                    case 8:
                        throw error;
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        return function submitFormWithRetry() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(e) {
            var newFieldErrors, hasErrors, el, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        newFieldErrors = {
                            firstName: !formData.firstName || !validateName(formData.firstName),
                            lastName: !formData.lastName || !validateName(formData.lastName),
                            email: !formData.email || fieldValidation.email !== "valid",
                            phone: Boolean(formData.phoneNumber) && fieldValidation.phone !== "valid"
                        };
                        setFieldErrors(newFieldErrors);
                        hasErrors = newFieldErrors.fullName || newFieldErrors.email || newFieldErrors.phone;
                        if (hasErrors) {
                            setShowInputErrorToast(true);
                            el = document.querySelector('input[aria-invalid="true"]');
                            if (el) {
                                el.focus();
                                el.scrollIntoView({
                                    block: "center"
                                });
                            }
                            return [
                                2
                            ];
                        }
                        setIsSubmitting(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            submitFormWithRetry()
                        ];
                    case 2:
                        _state.sent();
                        setShowSuccessToast(true);
                        setTimeout(function() {
                            window.location.assign(components_shared_constants__WEBPACK_IMPORTED_MODULE_2__/* .LandingPageRoutes.AGENTS */ .I.AGENTS);
                        }, 4000);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        setShowErrorToast(true);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsSubmitting(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .FormLayout */ .l, {
        formId: "key-agent-signup-form",
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .FormLayout.ScrollContainer */ .l.ScrollContainer, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .FormLayout.TopNav */ .l.TopNav, {
                        navLabel: "Opendoor Key Agent™",
                        textButtonProps: {
                            label: "Exit",
                            href: components_shared_constants__WEBPACK_IMPORTED_MODULE_2__/* .LandingPageRoutes.AGENTS */ .I.AGENTS,
                            analyticsName: "key-agent-signup-exit"
                        }
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .FormLayout.FormContent */ .l.FormContent, {
                        animationKey: 1,
                        skipEnterAnimation: true,
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .FormLayout.Title */ .l.Title, {
                                title: "Sign up to be an Opendoor Key Agent™",
                                subhead: "Enter your details to stay connected with us and access free Silver Tier membership"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .FormLayout.QuestionContainer */ .l.QuestionContainer, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .TextInput */ .o, {
                                        title: "First name",
                                        inputMode: "text",
                                        required: true,
                                        id: "firstName",
                                        $largerThanMD: {
                                            size: "large"
                                        },
                                        size: "medium",
                                        analyticsName: "key-agent-signup-first-name",
                                        value: formData.firstName,
                                        onChangeText: function(value) {
                                            return handleInputChange("firstName", value);
                                        },
                                        errorText: fieldErrors.firstName ? "Please enter your first name to continue" : undefined
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .TextInput */ .o, {
                                        title: "Last name",
                                        inputMode: "text",
                                        required: true,
                                        id: "lastName",
                                        $largerThanMD: {
                                            size: "large"
                                        },
                                        size: "medium",
                                        analyticsName: "key-agent-signup-last-name",
                                        value: formData.lastName,
                                        onChangeText: function(value) {
                                            return handleInputChange("lastName", value);
                                        },
                                        errorText: fieldErrors.lastName ? "Please enter your last name to continue" : undefined
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .ValidatedTextInput */ .O, {
                                        title: "Email address",
                                        required: true,
                                        format: "emailAddress",
                                        id: "email",
                                        $largerThanMD: {
                                            size: "large"
                                        },
                                        size: "medium",
                                        analyticsName: "key-agent-signup-email",
                                        value: formData.email,
                                        onChangeText: function(value) {
                                            return handleInputChange("email", value);
                                        },
                                        onValidationChange: function(state) {
                                            return setFieldValidation((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, fieldValidation), {
                                                email: state
                                            }));
                                        },
                                        errorText: fieldErrors.email ? "Please enter a valid email address to sign up, should include an @ and domain (ex. .com)." : undefined
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .ValidatedTextInput */ .O, {
                                        title: "Phone number",
                                        id: "phone",
                                        format: "telephoneNumber",
                                        $largerThanMD: {
                                            size: "large"
                                        },
                                        size: "medium",
                                        analyticsName: "key-agent-signup-phone",
                                        value: formData.phoneNumber,
                                        onChangeText: function(value) {
                                            return handleInputChange("phoneNumber", value);
                                        },
                                        onValidationChange: function(state) {
                                            return setFieldValidation((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, fieldValidation), {
                                                phone: state
                                            }));
                                        }
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .TextInput */ .o, {
                                        title: "Brokerage name",
                                        supportText: "Share which brokerage you hang your license with",
                                        id: "brokerage",
                                        $largerThanMD: {
                                            size: "large"
                                        },
                                        size: "medium",
                                        analyticsName: "key-agent-signup-brokerage",
                                        value: formData.brokerage,
                                        onChangeText: function(value) {
                                            return handleInputChange("brokerage", value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .TextInput */ .o, {
                                        title: "MLS ID",
                                        id: "mlsId",
                                        $largerThanMD: {
                                            size: "large"
                                        },
                                        size: "medium",
                                        analyticsName: "key-agent-signup-mls-id",
                                        value: formData.mlsId,
                                        onChangeText: function(value) {
                                            return handleInputChange("mlsId", value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .TextInput */ .o, {
                                        title: "MLS Name",
                                        id: "mlsName",
                                        $largerThanMD: {
                                            size: "large"
                                        },
                                        size: "medium",
                                        analyticsName: "key-agent-signup-mls-name",
                                        value: formData.mlsName,
                                        onChangeText: function(value) {
                                            return handleInputChange("mlsName", value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__/* .CheckboxGroup */ .c, {
                                        "$group-formLayout-largerThanMD": {
                                            size: "large"
                                        },
                                        size: "medium",
                                        analyticsName: "key-agent-signup-checkbox-group",
                                        id: "interests",
                                        options: [
                                            {
                                                label: "Cash offers for your clients",
                                                value: "cash_offers"
                                            },
                                            {
                                                label: "Receiving leads from Opendoor",
                                                value: "leads"
                                            },
                                            {
                                                label: "Toolkits and resources",
                                                value: "toolkits"
                                            },
                                            {
                                                label: "Key agent events",
                                                value: "events"
                                            }, 
                                        ],
                                        supportText: "Select all that apply",
                                        title: "What about the Opendoor Key Agent™ program interests you?",
                                        onPress: function(interests) {
                                            return handleInputChange("interests", interests);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .SimpleCheckbox */ .A, {
                                        id: "marketing-consent",
                                        analyticsName: "key-agent-signup-consent",
                                        checked: formData.agreeToMarketing,
                                        onPress: function(_, checked) {
                                            handleInputChange("agreeToMarketing", checked);
                                        },
                                        label: "I consent to receive marketing calls and texts from Opendoor and its affiliates to the number provided. I understand that I may opt out at any time and consent is not a condition of purchase.",
                                        value: "marketing-consent",
                                        size: "small"
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                                        typography: "$bodySmall",
                                        tag: "span",
                                        color: "$contentSecondary",
                                        children: [
                                            'By clicking "Sign up" I agree to Opendoor’s',
                                            " ",
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Link */ .r, {
                                                analyticsName: "terms-of-service-key-agent-signup",
                                                href: "/terms",
                                                size: "small",
                                                variant: "primary",
                                                children: "terms of service"
                                            }),
                                            " ",
                                            "and",
                                            " ",
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Link */ .r, {
                                                analyticsName: "privacy-policy-key-agent-signup",
                                                href: "/privacy",
                                                size: "small",
                                                variant: "primary",
                                                children: "privacy policy"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__/* .Button */ .z, {
                                        variant: "primary",
                                        label: "Sign up",
                                        size: "large",
                                        analyticsName: "key-agent-signup-submit",
                                        loading: isSubmitting,
                                        disabled: isSubmitting,
                                        alignSelf: "flex-end",
                                        $smallerThanMD: {
                                            alignSelf: "stretch"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_17__/* .Box */ .x, {
                                        mb: "$12x",
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .FormLayout.LegalCopy */ .l.LegalCopy, {
                                            links: [
                                                {
                                                    text: "Do Not Sell My Info",
                                                    analyticsName: "key-agent-do-not-sell-my-info",
                                                    href: components_shared_constants__WEBPACK_IMPORTED_MODULE_2__/* .FooterRoutes.PRIVACY_REQUEST */ .i.PRIVACY_REQUEST
                                                },
                                                {
                                                    text: "Notice at collection",
                                                    analyticsName: "key-agent-notice-at-collection",
                                                    href: components_shared_constants__WEBPACK_IMPORTED_MODULE_2__/* .FooterRoutes.CCPA */ .i.CCPA
                                                },
                                                {
                                                    text: "Terms of Service",
                                                    analyticsName: "key-agent-terms-of-service",
                                                    href: components_shared_constants__WEBPACK_IMPORTED_MODULE_2__/* .FooterRoutes.TERMS_OF_SERVICE */ .i.TERMS_OF_SERVICE
                                                },
                                                {
                                                    text: "Privacy Policy",
                                                    analyticsName: "key-agent-privacy-policy",
                                                    href: components_shared_constants__WEBPACK_IMPORTED_MODULE_2__/* .FooterRoutes.PRIVACY_POLICY */ .i.PRIVACY_POLICY
                                                }, 
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_18__/* .Toast */ .F, {
                message: "Thanks for submitting your information! We’ll be in touch with more info in the coming months",
                isOpen: showSuccessToast,
                isSuccess: true,
                onClose: function() {
                    return setShowSuccessToast(false);
                },
                duration: 4000
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_18__/* .Toast */ .F, {
                message: "Sorry, there was an error submitting your form. Please try again.",
                isOpen: showErrorToast,
                hasError: true,
                onClose: function() {
                    return setShowErrorToast(false);
                },
                duration: 4000
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_18__/* .Toast */ .F, {
                message: "Please complete the required fields, full name and email address.",
                isOpen: showInputErrorToast,
                hasError: true,
                onClose: function() {
                    return setShowInputErrorToast(false);
                },
                duration: 4000
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (KeyAgentSignUp);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6852,6523,9652,6398,4746,5569,4370,677,9770,9774,2888,179], function() { return __webpack_exec__(15817); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);